import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wa-phone-preview" }
const _hoisted_2 = { class: "wa-phone-preview__header" }
const _hoisted_3 = { class: "wa-phone-preview__identity" }
const _hoisted_4 = { class: "wa-phone-preview__name" }
const _hoisted_5 = { class: "wa-phone-preview__status" }
const _hoisted_6 = { class: "wa-phone-preview__chat" }
const _hoisted_7 = {
  key: 1,
  class: "wa-phone-preview__bubble-row"
}
const _hoisted_8 = { class: "wa-phone-preview__bubble" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "wa-phone-preview__meta" }
const _hoisted_11 = {
  key: 2,
  class: "wa-phone-preview__empty"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppPhonePreview',
  props: {
    formattedMessage: {}
  },
  setup(__props: any) {



const timeStr = new Date().toLocaleTimeString('es', { hour: '2-digit', minute: '2-digit' })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "wa-phone-preview__avatar" }, [
        _createElementVNode("em", { class: "fa-brands fa-whatsapp" })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('wp.preview.business_name')), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('wp.preview.online')), 1)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "wa-phone-preview__actions" }, [
        _createElementVNode("em", { class: "fas fa-video" }),
        _createElementVNode("em", { class: "fas fa-phone" }),
        _createElementVNode("em", { class: "fas fa-ellipsis-vertical" })
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.$slots.default)
        ? _renderSlot(_ctx.$slots, "default", { key: 0 })
        : (__props.formattedMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "wa-phone-preview__bubble-tail" }, null, -1)),
                _createElementVNode("div", {
                  class: "wa-phone-preview__bubble-content",
                  innerHTML: __props.formattedMessage
                }, null, 8, _hoisted_9),
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_unref(timeStr)) + " ", 1),
                  _cache[2] || (_cache[2] = _createElementVNode("em", { class: "fas fa-check-double" }, null, -1))
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('wp.preview.empty_hint')), 1))
    ])
  ]))
}
}

})